import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, CalendarDays, ClipboardList, Users, UserCog, Tags, Megaphone, Ticket, Gift, FileText, MapPin, Clock, Star, Settings, LogOut, ExternalLink, Bot, Plug } from "lucide-react";
import { Logo } from "@/components/brand/Logo";
import { useAuth } from "@/context/AuthContext";

export const ADMIN_NAV = [
  ["Dashboard", "/admin", LayoutDashboard], ["Bookings", "/admin/bookings", ClipboardList], ["Calendar", "/admin/calendar", CalendarDays],
  ["Customers", "/admin/customers", Users], ["Cleaners", "/admin/cleaners", UserCog], ["Pricing", "/admin/pricing", Tags],
  ["Promotions", "/admin/promotions", Megaphone], ["Promo Codes", "/admin/promo-codes", Ticket], ["Rewards", "/admin/rewards", Gift],
  ["Invoices", "/admin/invoices", FileText], ["Service Areas", "/admin/service-areas", MapPin], ["Availability", "/admin/availability", Clock],
  ["Reviews", "/admin/reviews", Star], ["Content", "/admin/content", FileText], ["AI Chatbot", "/admin/ai", Bot], ["Integrations", "/admin/integrations", Plug], ["Settings", "/admin/settings", Settings],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen lg:grid lg:grid-cols-[260px_1fr]" data-testid="admin-layout">
      <aside className="border-b lg:border-b-0 lg:border-r border-[#E5E2DA] bg-white lg:sticky lg:top-0 lg:h-screen flex flex-col">
        <div className="p-5 border-b border-[#E5E2DA] flex items-center justify-between"><Logo to="/admin" testId="admin-logo" /><span className="text-[10px] font-bold tracking-widest uppercase text-[var(--kc-terracotta)]">Admin</span></div>
        <nav className="p-3 flex lg:flex-col gap-1 overflow-x-auto lg:overflow-y-auto flex-1" aria-label="Admin">
          {ADMIN_NAV.map(([label, to, Icon]) => (
            <NavLink key={to} to={to} end={to === "/admin"} data-testid={`admin-sidebar-${label.toLowerCase().replace(/\s/g, "-")}-link`}
              className={({ isActive }) => `admin-nav-link whitespace-nowrap ${isActive ? "active" : ""}`}>
              <Icon className="w-4 h-4 shrink-0" />{label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[#E5E2DA] text-sm">
          <p className="font-medium truncate" data-testid="admin-user-email">{user?.email}</p>
          <div className="mt-2 flex gap-3">
            <Link to="/" className="text-[var(--kc-blue)] inline-flex items-center gap-1 hover:underline"><ExternalLink className="w-3.5 h-3.5" /> View site</Link>
            <button onClick={logout} data-testid="admin-logout-button" className="text-[#5A606A] inline-flex items-center gap-1 hover:text-[var(--kc-text)]"><LogOut className="w-3.5 h-3.5" /> Log out</button>
          </div>
        </div>
      </aside>
      <main className="p-5 sm:p-8 lg:p-10 min-w-0"><Outlet /></main>
    </div>
  );
}

export const AdminPage = ({ title, subtitle, actions, children, testId }) => (
  <div data-testid={testId}>
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
      <div><h1 className="text-3xl font-semibold">{title}</h1>{subtitle && <p className="mt-1 text-[#5A606A]">{subtitle}</p>}</div>
      {actions}
    </div>
    {children}
  </div>
);

export const ComingSoon = ({ title, phase }) => (
  <AdminPage title={title} subtitle={`Planned for Phase ${phase}.`} testId={`admin-${title.toLowerCase().replace(/\s/g, "-")}-page`}>
    <div className="kc-card p-10 text-[#5A606A]">This section is scheduled for a later build phase.</div>
  </AdminPage>
);
